import { render } from "./BtnPracticeRestart.vue?vue&type=template&id=6758640a&scoped=true"
import script from "./BtnPracticeRestart.vue?vue&type=script&lang=js"
export * from "./BtnPracticeRestart.vue?vue&type=script&lang=js"

import "@/css/components/btn-practice-restart.css?vue&type=style&index=0&id=6758640a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6758640a"]])

export default __exports__